export type LgvSelectOption = {
  value: string;
  label: string;
};

type RawSelectOption = {
  label?: string;
  text?: string;
  value?: string | number | boolean | null;
};

/** Standard form questions: option value comes from `value`. */
export function normalizeQuestionSelectOptions(
  options: RawSelectOption[] | undefined,
): LgvSelectOption[] {
  if (!options?.length) return [];

  return options.map((opt) => {
    const label = String(opt.label ?? opt.text ?? "").trim();
    const value =
      opt.value !== undefined && opt.value !== null ? String(opt.value) : "";
    return {
      value,
      label: label || value,
    };
  });
}

/** Composite sub-fields and legacy flows may fall back to label/text as value. */
export function normalizeCompositeSelectOptions(
  options: RawSelectOption[] | undefined,
): LgvSelectOption[] {
  if (!options?.length) return [];

  return options.map((opt) => {
    const label = String(opt.label ?? opt.text ?? "").trim();
    const rawValue =
      opt.value !== undefined && opt.value !== null && opt.value !== ""
        ? opt.value
        : (opt.label ?? opt.text ?? "");
    const value = String(rawValue);
    return {
      value,
      label: label || value,
    };
  });
}
